<script setup lang="ts">
import { BALLOON_TEXT } from '@/constants/statesOfAddressSystem'

import type { DeliveryDataAddress } from '@/store/delivery/delivery.types'

type Props = {
  selectedAddress: DeliveryDataAddress | null
  isEmptyInfo: boolean
  isLoading?: boolean
}

const props = defineProps<Props>()

const titleAddress = computed(() => {
  return (
    props.selectedAddress?.address.address?.value ||
    BALLOON_TEXT.addressNotFound
  )
})
</script>

<template>
  <div v-if="isEmptyInfo" class="balloon__message">
    {{ BALLOON_TEXT.outsideDelivery }}
  </div>

  <div v-else-if="isLoading" class="balloon__progress">
    <the-loader size="14" color="var(--ui-white)" />
  </div>

  <p v-else-if="titleAddress" class="balloon__address">
    {{ titleAddress }}
  </p>
</template>

<style lang="scss" scoped>
.balloon {
  &__progress {
    position: relative;
    width: 14px;
    height: 14px;
    margin: 0 5px 8px 0;
  }

  &__message {
    margin: 0 auto;
    font-weight: 600;
  }

  &__address {
    display: -webkit-box;
    margin-bottom: 8px;
    overflow: hidden;
    font-weight: 800;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: break-spaces;
  }
}
</style>
